
import {useGSAP} from "@gsap/react";
import ScrollToTop from '../ui/ScrollToTop';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useRef, useState } from "react";

const ScrollToTopChecker = () => {

    const [isScrollToTopActive, setIsScrollToTopActive] = useState(false)

    const sectionRef = useRef(null)

    useGSAP(()=> {
            ScrollTrigger.create({
                trigger: sectionRef.current,
                start: "bottom center",   
                end: "bottom center",  
                onEnter: () => setIsScrollToTopActive(true),
                onEnterBack: () => setIsScrollToTopActive(true),
                onLeaveBack: () => setIsScrollToTopActive(false),
                });
    })

    return (
        <div className="pointer-events-none flex items-end justify-end absolute w-full top-0 left-0 h-[200rem]">
          <div  ref={sectionRef} className="w-full h-[100vh]">
          <ScrollToTop isActive={isScrollToTopActive}>
          </ScrollToTop>
          </div>
        </div>
    );
};

export default ScrollToTopChecker;